export default {"src":"/_next/static/media/videocall_64.0544a113.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};